module.exports = __webpack_public_path__ + "img/6.92d0d9b4.png";